// Login.js

import React, { Component } from 'react';
import Form from "react-jsonschema-form";
import JSONSchemaForm from "react-jsonschema-form";
import { connect } from 'react-redux';
import { updateUser } from '../actions/user-actions';
import { updateAlert } from '../actions/alert-actions';
import { history } from '../helpers/history';

class Login extends Component {

  constructor(props) {
    super(props);
    this.props.onUpdateAlert("")
    this.state = {
      Form: JSONSchemaForm.default,
      jsonSchema: {
      "title": "Login",
      "type": "object",
      "required": [
        "email",
        "password"
      ],
      "properties": {
        "email": {
          "type": "string",
          "title": "Email Address"
        },
        "password": {
          "type": "string",
          "title": "Password",
          "minLength": 3
        }
      }
    },
    uiSchema: {
      "email": {
        "ui:autofocus": true,
        "ui:emptyValue": ""
      },
      "password": {
        "ui:widget": "password",
      }
    },
  }
}

  onUpdateUser(token){
    console.log('updating... in login page:', token);
    this.props.onUpdateUser(token);
  }

  onUpdateAlert(message, type){
    console.log('Alert:', message, type);
    this.props.onUpdateAlert(message, type);
  }

  render() {
    return (
      <div class="loginView">
      

                      <div className="container">
                    <div className="col-sm-6 offset-sm-3 mt-2">
                        {this.props.alert &&
                            <div className={'alert alert-warning'}>{this.props.alert}</div>
                        }
                    </div>
                </div>
                <div className="container">
                    {this.props.children}
                </div>
      <Form schema={this.state.jsonSchema}
        showErrorList={true}
        className="form form-wide"
        uiSchema={this.state.uiSchema}
        onSubmit={this.onSubmit.bind(this)}
        />

      <button className='btn btn-info' onClick={this.props.history.goBack}>Back</button>
      </div>
    );
  }

  onSubmit(formData) {
    console.log("authenticate:", formData.formData);
    var response = fetch('https://beiseker.bookice.ca/api/v0/login', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData.formData)
    }).then(response => {
            if (!response.ok) {
                console.log(response.statusText);
                return Promise.reject(response.statusText);
            }
            console.log(response.statusText);
            return response.json();
        })
        .catch(error => {
          console.log(error);
          //this.props.onUpdateAlert("Login Failed, please try again");
        })
        .then(json => {
            if (json && json.token) {
                //localStorage.setItem('token', token);
                console.log('token', json);
                console.log('updating... in onSubmit:', json);
                this.props.onUpdateAlert("");
                this.props.onUpdateUser(json);
                history.goBack();
                
            } else {
              this.props.onUpdateAlert("Login Failed, please try again");
              //this.props.alert = "Login Failed, please try again";
            }
        });
 
 }
}


const mapStateToProps = state => ({
  cart: state.cart,
  user: state.user,
  alert: state.alert
});

const mapActionsToProps = {
  onUpdateUser: updateUser,
  onUpdateAlert: updateAlert
};


export default connect(mapStateToProps, 
  mapActionsToProps
  )(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js